module.exports = __webpack_public_path__ + "static/media/LogoWP.095b4dff.png";